<mat-checkbox
	[formControl]="formControl"
	(change)="onChange($event)"
	[checked]="value"
>
	<bcb-generic-label [question]="question"></bcb-generic-label>
</mat-checkbox>
<mat-error *ngIf="formControl?.invalid">{{ errorMessage }}</mat-error>
